import React, { useEffect, useState } from "react";
import {
  Box,
  InputBase,
  IconButton,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Avatar,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import TuneIcon from "@mui/icons-material/Tune";
import AvatarImage from "../../../../Assets/Images/Chatbot_Avatar.png";
import { GridTableRowsIcon, GridViewColumnIcon } from "@mui/x-data-grid";
import { clearChatbotPublicStatus } from "../../../../Redux/Slices/ChatbotPublic/ChatbotPublicSlicer";
import { useDispatch } from "react-redux";
import ChatbotPublic from "../../../../Components/ChatbotPublic/ChatbotPublic";
import {
  AiDriveSearch,
  clearAiDriveSearch,
} from "../../../../Redux/Slices/Booklet/Tutor/AiSearch/AiSearch";

export interface SearchBarProps {
  placeholder?: string;
  disabled?: boolean;
  onSearchChange?: (value: string) => void;
  subject_id?:string| number;
}

const SearchBar: React.FC<SearchBarProps> = ({
  placeholder = "Search in Drive Data",
  disabled = false,
  subject_id,
  onSearchChange,
}) => {
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const [value, setValue] = useState("");
  const [chatbotOpen, setChatbotOpen] = React.useState<boolean>(false);

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }
  };

const handleSubmit = () => {
  if (value.trim() !== "") {
    const payload: { query: string; subject_id?: number | string } = {
      query: value,
    };
    if (subject_id !== undefined && subject_id !== null && subject_id !== "") {
      payload.subject_id = subject_id;
    }

    dispatch(AiDriveSearch(payload));
  }
};
  useEffect(() => {
    clearAiDriveSearch();
  }, []);

  return (
    <>
      <div style={{ display: "flex", flexDirection: "row", gap: "15px" }}>
        <Paper
          component="form"
          sx={{
            p: "2px 8px",
            display: "flex",
            alignItems: "center",
            width: "100%",
            borderRadius: "10px",
            boxShadow: "none",
            border: "2px solid #cfceceff",
          }}
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit(); // call the dispatch
          }}
        >
          <SearchIcon sx={{ color: "gray", mr: 1 }} />

          <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder={placeholder}
            value={value}
            onChange={(e) => {
              setValue(e.target.value);
              onSearchChange?.(e.target.value); 
            }}
            onKeyPress={handleKeyPress}
            disabled={disabled}
          />

          {/* <IconButton onClick={() => setOpen(true)}>
          <TuneIcon />
        </IconButton> */}
        </Paper>
        {/* <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <IconButton sx={{ p: 0 }}
          onClick={() => {
              setChatbotOpen(true);
              dispatch(clearChatbotPublicStatus());
            }}>
          <Avatar sx={{
            backgroundColor:"#009dff"
          }}
                  src={AvatarImage}
                  alt="Profile"
                  className="blinking-avatar1"
                />
        </IconButton> */}
        {/* <IconButton
          sx={{
            p: 1.2,
            backgroundColor: "#2196f3", 
            borderRadius: "10px",
            "&:hover": {
              backgroundColor: "#1976d2",
            },
          }}
        >
          <GridTableRowsIcon sx={{ color: "white" }} />
        </IconButton>
        <IconButton
          sx={{
            p: 1.2,
            borderRadius: "10px",
            "&:hover": {
              backgroundColor: "#f0f0f0",
            },
          }}
        >
          <GridViewColumnIcon />
        </IconButton> */}
        {/* </Box> */}
        <Button
          sx={{
            p: 1.2,
            backgroundColor: "#2196f3",
            textTransform: "none",
            fontSize: "14px",
            fontWeight: "500",
            padding: "6px 12px",
            color: "#ffffff",
            borderRadius: "10px",
            "&:hover": {
              backgroundColor: "#1976d2",
            },
          }}
          onClick={handleSubmit}
        >
          Search
        </Button>
      </div>

      <ChatbotPublic open={chatbotOpen} setOpen={setChatbotOpen} />

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{
          sx: {
            borderRadius: "12px",
            p: 1,
            width: "100%",
            maxWidth: "425px",
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: 600, fontSize: "18px" }}>
          Search By Filter
        </DialogTitle>
        <DialogContent
          dividers
          sx={{ display: "flex", flexDirection: "column", gap: 2 }}
        >
          {/* File Type */}
          <FormControl fullWidth>
            <Typography>Year of Group</Typography>
            <Select defaultValue="">
              <MenuItem value="">Any</MenuItem>
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <Typography>Subject</Typography>
            <Select defaultValue="">
              <MenuItem value="">Any</MenuItem>
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <Typography>Topic</Typography>
            <Select defaultValue="">
              <MenuItem value="">Any</MenuItem>
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <Typography>Subtopic</Typography>
            <Select defaultValue="">
              <MenuItem value="">Any</MenuItem>
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <Typography>Tags</Typography>
            <Select defaultValue="">
              <MenuItem value="">Any</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={() => setOpen(false)}>
            Apply
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SearchBar;
